<template>
  <aside>
    <header>
      <h3 v-if="typeRecharge === ProductType.ApiCalls">
        {{ isInfinite ? "Recarga tu saldo para API calls aquí" : "Pronto podrás recargar tu saldo para API calls aquí" }}
      </h3>
      <h3 v-else>
        Recarga tu saldo {{ getProductName(typeRecharge) }} aquí
      </h3>

      <img src="../../assets/coin.png" alt="coin icon" />
    </header>

    <p v-if="typeRecharge === ProductType.WhatsApp">
      Envía y recibe mensajes de sesión o plantillas de WhatsApp.
    </p>

    <p v-if="typeRecharge === ProductType.WhatsAppVoice">
      Envía plantillas de llamada vía WhatsApp y permite que te llamen.
    </p>

    <p v-if="typeRecharge === ProductType.Voice">
      Realiza llamadas salientes de forma manual o por estrategia.
    </p>

    <p v-if="typeRecharge === ProductType.Sms">
      Envía SMS salientes de forma manual o por estrategia.
    </p>

    <p v-if="typeRecharge === ProductType.BotAI">
      Integra bots AI en tus canales de mensajería para agilizar la atención de tickets.
    </p>

    <p v-if="typeRecharge === ProductType.TextToSpeech">
      Genera audios personalizados para tus estrategias de IVR.
    </p>

    <p v-if="typeRecharge === ProductType.ApiCalls">
      Adquiere API calls para poder utilizar las nuevas APIs v2 y MCP.
    </p>

    <section>
      <div>
        <small>Recarga tu saldo de:</small>

        <a-select
          v-model:value="typeRecharge"
          class="input"
          :disabled="isInfinite && typeRecharge !== ProductType.ApiCalls"
        >
          <a-select-option v-for="option in optionsType" :key="option.key">
            <icon-channel 
              v-if="option.channel || option.key == ProductType.TextToSpeech || option.key == ProductType.ApiCalls" 
              :type="option.channel || option.key" 
              :width="20" 
              :isTTS="option.key == ProductType.TextToSpeech" 
              :isApiCalls="option.key == ProductType.ApiCalls"
            /> {{ option.label }}
          </a-select-option>
        </a-select>
      </div>

      <template v-if="typeRecharge === ProductType.ApiCalls && isInfinite">
        <small style="margin-top: 10px">Monto a recargar</small>
        <a-input-number
          class="input"
          :value="amount"
          :min="minVal"
          :precision="2"
          disabled
        />
        <h5>El monto mínimo es $5.00</h5>

        <small style="margin-top: 10px">API calls a recargar</small>
        <a-input class="input" :value="apiCallsCalculated" disabled />

        <a-button
          class="button payment-button"
          disabled
          style="width: 100%; margin-top: 20px"
        >
          Recargar saldo
        </a-button>
      </template>

      <template v-else-if="typeRecharge === ProductType.ApiCalls">
        <a-tooltip
          title="Estamos trabajando en esta función. Pronto podrás recargar saldo para tus API calls."
        >
          <span style="display: block; margin-top: 20px">
            <a-button
              class="button payment-button"
              disabled
              style="width: 100%"
            >
              Recargar saldo
            </a-button>
          </span>
        </a-tooltip>
      </template>

      <template v-else>
        <small style="margin-top: 10px">
          Ingresa el monto que necesitas
        </small>

        <a-input-number
          class="input"
          v-model:value="amount"
          :min="minVal"
          :precision="2"
          :disabled="isInfinite"
        />

        <h5 v-if="typeRecharge === ProductType.WhatsApp">
          El monto mínimo es $10.00
        </h5>

        <h5 v-if="typeRecharge === ProductType.WhatsAppVoice">
          El monto mínimo es $10.00
        </h5>

        <h5 v-if="typeRecharge === ProductType.Voice">
          El monto mínimo es $5.00
        </h5>

        <h5 v-if="typeRecharge === ProductType.Sms">
          El monto mínimo es $5.00
        </h5>

        <h5 v-if="typeRecharge === ProductType.BotAI">
          El monto mínimo es $10.00.
        </h5>

        <h5 v-if="typeRecharge === ProductType.TextToSpeech">
          El monto mínimo es $5.00.
        </h5>

        <div class="section_price__details--item">
          <span>Monto de recarga</span>
          <span>${{ amount }}</span>
        </div>
        <div v-if="rechargeTax" class="section_price__details--item">
          <span>IGV ({{ Math.round(rechargeTax * 100) }}%)</span>
          <span>${{ igvSlot }}</span>
        </div>

        <a-divider class="divider2" />

        <h4 class="total">Total: ${{ totalIncludeIgv }}</h4>

        <a-button
          v-if="requiredUpgrade"
          class="button payment-button"
          type="primary"
          @click="handleOpenRestriction(typeRecharge)"
          :disabled="isInfinite"
        >
          Recargar saldo
        </a-button>
        <PayUPaymentButton
          v-else
          :amount="totalIncludeIgv"
          :type="typeRecharge"
          :title="titleRecharge"
          :disabled="isInfinite"
          @update="$emit('update')"
          @success="handleOpenModal('success')"
          @reject="handleOpenModal('error')"
        />
      </template>
    </section>

    <a-divider class="divider" />

    <footer v-if="typeRecharge === ProductType.WhatsApp">
      <h3>Información de precios</h3>

      <p>¡Solo paga por lo que consumes!</p>

      <InfoCard
        class="info__card"
        color="#FAAD14"
        title="Precio por mensaje de sesión"
        description="$0.0030"
        info="por mensaje enviado o recibido"
      />

      <InfoCard
        class="info__card"
        color="#A0D911"
        title="Precio por inicio de conversación"
        description="Según el país de destino"
      />

      <p class="info__text">
        ¿Deseas conocer más a detalle esta información?
        <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer"> Click aquí. </a>
      </p>
    </footer>

    <footer v-if="typeRecharge === ProductType.WhatsAppVoice">
      <h3>Información de precios</h3>

      <p>¡Solo paga por lo que consumes!</p>

      <WhatsappVoiceCard
        class="info__card"
        color="#FAAD14"
        title="Precio por llamada entrante"
        description="$0.0003"
        info="por segundo consumido"
      />

      <p class="info__text">
        ¿Deseas conocer más a detalle esta información?
        <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer"> Click aquí. </a>
      </p>
    </footer>
    <footer v-if="typeRecharge === ProductType.TextToSpeech">
      <h3>Información de precios</h3>

      <p>¡Solo paga por lo que consumes!</p>

      <priceCharacterCard
        class="info__card"
        color="#FAAD14"
        title="Precio por caracter"
        :description="`$${ttsPricing.character}`"
      />

      <VariablePriceCard
        class="info__card"
        color="#A0D911"
        title="Precio por variable"
        :description="`$${ttsPricing.variable}`"
      />

      <p class="info__text">
        ¿Deseas conocer más a detalle esta información?
        <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer"> Click aquí. </a>
      </p>
    </footer>

    <footer v-if="typeRecharge === ProductType.ApiCalls">
      <h3>Información de precios</h3>

      <p>¡Solo paga por lo que consumes!</p>

      <ApiCallPriceCard
        class="info__card"
        title="Precio por API call"
        :description="`$${API_CALL_PRICE}`"
      />
    </footer>
  </aside>

  <TransactionStateModal v-model:open="transactionModal.open" :state="transactionModal.state" />
</template>

<script setup lang="ts">
import { ref, computed, reactive, watch, inject, Ref, toRefs, onMounted } from "vue";
import { ProductType } from "@/@types/settings/billing";
import { TtsModel, TtsVoiceType } from "@/@types/strategies/modalStrategy";

import PayUPaymentButton from "@/app/shared/components/buttons/PayUPaymentButton.vue";
import TransactionStateModal from "@/app/settings/components/modals/TransactionStateModal.vue";
import InfoCard from "./InfoCard.vue";
import priceCharacterCard from "./PriceCharacterCard.vue";
import ApiCallPriceCard from "./ApiCallPriceCard.vue";
import VariablePriceCard from "./VariablePriceCard.vue";
import WhatsappVoiceCard from "./WhatsappVoiceCard.vue";
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";
import { ChannelType } from "@/app/shared/utils/enums";
import { ISlots } from "@/@types/settings/slots";
import { useStore } from "vuex";
import { fetchTtsPricing } from "@/app/strategies/services";

const DEFAULT_TTS_CHARACTER_COST = 0.000004;
const DEFAULT_TTS_VARIABLE_COST = 0.0008;
const props = defineProps<{ 
  type: ProductType; 
  minVal: number; 
  isInfinite: boolean;
  slots: ISlots | undefined;
  // Tasa de IGV del producto (0.18 Peru, 0 resto). Si no viene, se usa el flag
  // del plan para no cambiar el comportamiento de los demas productos.
  igvRate?: number;
}>();

const { slots } = toRefs(props);

const rechargeTax = computed(() => {
  if (props.igvRate !== undefined) return props.igvRate;
  return slots?.value?.tax ?? 0;
});

const amount = ref(5);
const ttsPricing = reactive({
  character: DEFAULT_TTS_CHARACTER_COST,
  variable: DEFAULT_TTS_VARIABLE_COST,
});
const store = useStore();
const user = computed(() => store.getters["getDataUser"]);
const isClientBeexcc = computed(() => user.value?.is_beexcc);

watch(
  () => props.minVal,
  () => {
    amount.value = props.minVal;
  },
  {
    immediate: true,
  }
);

const typeRecharge = ref(props.type);
const optionsType = ref([
  {
    key: ProductType.Voice,
    label: "Llamadas",
    channel: ChannelType.Voice,
  },
  {
    key: ProductType.WhatsApp,
    label: "WhatsApp",
    channel: ChannelType.Whatsapp,
  },
  {
    key: ProductType.Sms,
    label: "SMS",
    channel: ChannelType.Sms,
  },
  ...(props.type === ProductType.BotAI
    ? [
        {
          key: ProductType.BotAI,
          label: "BotAI Message",
          channel: ChannelType.BotAI,
        },
      ]
    : []),
  ...(isClientBeexcc.value
    ? [
        {
          key: ProductType.WhatsAppVoice,
          label: "WhatsApp Voice",
          channel: ChannelType.WhatsappVoice,
        },
      ]
    : []),
  {
    key: ProductType.TextToSpeech,
    label: "Text To Speech",
  },
  {
    key: ProductType.ApiCalls,
    label: "API Calls",
  },
]);

const API_CALL_PRICE = 0.002;

const apiCallsCalculated = computed(() => {
  if (!amount.value) return "0";
  const calls = Math.floor(amount.value / API_CALL_PRICE);
  return calls.toLocaleString("en-US");
});

const formattedAmountEs = computed(() => {
  const val = Number(amount.value) || 0;
  return val.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
});

const formattedTotalEs = computed(() => {
  const val = Number(totalIncludeIgv.value) || 0;
  return val.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
});

const titleRecharge = computed(() => {
  const itemType = optionsType.value.find(el => el.key == typeRecharge.value);
  return `Recarga tu saldo de ${itemType?.label}`;
});

const formattedAmount = computed(() => Number.parseFloat(String(amount.value)).toFixed(2));

const totalIncludeIgv = computed(() => {
  const totalIncludeIgvValue = amount.value * (1 + rechargeTax.value);
  return Number(totalIncludeIgvValue.toFixed(2));
});

const igvSlot = computed(() => {
  const igvSlotValue = amount.value * rechargeTax.value;
  return Number(igvSlotValue.toFixed(2));
})

const transactionModal = reactive({
  open: false,
  state: "success",
});

const hasSms = inject<Ref<Boolean>>("hasSms", ref(false));
const hasWhatsapp = inject<Ref<Boolean>>("hasWhatsapp", ref(false));
const hasVoice = inject<Ref<Boolean>>("hasVoice", ref(false));

const requiredUpgrade = computed(() => {
  switch (typeRecharge.value) {
    case ProductType.WhatsApp:
      return !hasWhatsapp.value;

    case ProductType.Voice:
      return !hasVoice.value;

    case ProductType.Sms:
      return !hasSms.value;

    default:
      return false;
  }
});

const handleOpenRestriction = inject<(type: ProductType) => any>("handleOpenRestriction", () => {});

const handleOpenModal = (state: string) => {
  transactionModal.open = true;
  transactionModal.state = state;
};

const loadTtsPricing = async () => {
  try {
    const pricing = await fetchTtsPricing({
      model: TtsModel.Wavenet,
      voice: TtsVoiceType.Female,
    });
    const characterCost = Number(pricing?.sale_per_char ?? pricing?.sale_per_chat);
    const variableCost = Number(pricing?.sale_per_variable);

    ttsPricing.character = Number.isFinite(characterCost)
      ? characterCost
      : DEFAULT_TTS_CHARACTER_COST;
    ttsPricing.variable = Number.isFinite(variableCost)
      ? variableCost
      : DEFAULT_TTS_VARIABLE_COST;
  } catch {
    ttsPricing.character = DEFAULT_TTS_CHARACTER_COST;
    ttsPricing.variable = DEFAULT_TTS_VARIABLE_COST;
  }
};

onMounted(() => {
  if (typeRecharge.value === ProductType.TextToSpeech) {
    loadTtsPricing();
  }
});

const getProductName = (type: ProductType) => {
  switch (type) {
    case ProductType.WhatsApp:
      return "de WhatsApp";

    case ProductType.WhatsAppVoice:
      return "de WhatsApp Voice";

    case ProductType.Voice:
      return "para llamadas";

    case ProductType.Sms:
      return "para SMS";

    case ProductType.BotAI:
      return "de BotAI Message";
    case ProductType.TextToSpeech:
      return "para Text To Speech aquí";
    case ProductType.ApiCalls:
      return "para API calls";
      
    default:
      return "";
  }
};

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/recargas-y-gastos/`;
</script>

<style lang="sass" scoped>
h3, p
  margin: 0

h3
  color: $gray-9
  font-size: 16px
  font-weight: 600
  max-width: 230px

h4
  font-size: 16px
  font-weight: 600

p
  color: $gray-13
  font-size: 14px

small
  display: block
  color: $gray-9
  font-size: 12px

.divider
  background-color: $gray-5
  margin: 16px 0

.divider2
  background-color: $gray-5
  margin: 8px 0

aside
  border: 1px solid $gray-5
  border-radius: 8px
  padding: 16px
  height: 100%
  width: 100%
  overflow: auto
  grid-column: 3
  grid-row: 1/-1

  header
    display: flex
    justify-content: space-between
    margin-bottom: 4px

  section
    margin-top: 12px

  .input
    width: 100%

  .total
    text-align: right
    color: $gray-10
    margin: 8px 0

  .info
    &__card
      margin-top: 16px

    &__text
      margin-top: 24px
      color: $gray-8

.payment-button
  width: 100%
  margin-bottom: 10px

h5
  color: $gray-7
  font-size: $font-small
  font-weight: 400

.section_price
  &__details
    text-align: right
    &--item
      display: flex
      align-items: center
      justify-content: end
      text-align: right
      gap: 24px
      color: #00000073
</style>
